import { PERMISOS } from 'const/Permisos';
import * as yup from 'yup';

const schemaNuevosCriterios = isTienePermisos => {
  let schema = {};

  if (
    isTienePermisos(PERMISOS.matchFiltroNegocio) &&
    isTienePermisos(PERMISOS.matchFiltroSucursal) &&
    isTienePermisos(PERMISOS.matchFiltroResiduo) &&
    isTienePermisos(PERMISOS.matchFiltroRecursos)
  ) {
    //SUPERADMIN : Tiene todos los permisos
    //Los campos obligatorios solo son empresa-sucursal o residuos o recursos.
    schema = {
      empresa: yup
        .object()
        .typeError('Este campo es obligatorio')
        .required('Este campo es obligatorio'),
      sucursal: yup
        .object()
        .typeError('Este campo es obligatorio')
        .required('Este campo es obligatorio')
    };

    return yup.object().shape(schema);
  }

  //USUARIO ASESOR DE CIRCULARIDAD SI TIENE PERMISO SE REQUIERE VALIDACION
  if (isTienePermisos(PERMISOS.matchFiltroNegocio)) {
    schema.empresa = yup
      .object()
      .typeError('Este campo es obligatorio')
      .required('Este campo es obligatorio');
  }
  if (isTienePermisos(PERMISOS.matchFiltroSucursal)) {
    schema.sucursal = yup
      .object()
      .typeError('Este campo es obligatorio')
      .required('Este campo es obligatorio');
  }

  //USUARIO COMUN SIN VALIDACIONES.
  //USUARIO SIN NEGOCIO REGISTRADO SIN VALIDACIONES
  return yup.object().shape(schema);
};

export { schemaNuevosCriterios };
